export default __webpack_public_path__ + "static/illy-ea38c43877d3c30642d0b53acb9df362.jpg";